import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import Moment from 'react-moment';

import { addClient, listClients } from '../actions/client';
import { SelectPicker } from 'rsuite';
import ClientAdd from './ClientAdd';

var z = 0


class Clients extends React.Component {

  constructor() {
      super();
      this.state = {
          name: '',
          errors: {},
          list: []
      }
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.fetchApi = this.fetchApi.bind(this);
  }

  fetchApi() {
    let currentorg = localStorage.getItem('currentorg');
    this.props.listClients(currentorg, 'name', this.props.history);
  }

  componentDidMount() {
    this.fetchApi();
    this.timeout = setInterval(() => {
      this.fetchApi();
    }, 10000)
  }


  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleInputChange(n, v ) {
      this.setState({
          [n]: v
      })
  }

  handleSubmit(e) {
      e.preventDefault();
      const organization = {
          name: this.state.name,
          organization: localStorage.getItem('currentorg')
      }
      this.props.addClient(organization, this.props.history);
  }

    render() {
      const { errors } = this.state;
    //   console.log(this.props);
      return (
          <div className="component clients">
            <h1>Klienci</h1>
              <div className="component-header">
                <div className="left">
                  <SelectPicker
                    data={[{ label: 'Nazwa', value: 'name' },{ label: 'Data', value: 'date' }]}
                    searchable={false}
                    defaultValue={'name'}
                    cleanable={false}
                    onChange={this.handleSortSelect}
                  />
                </div>
                <div className="right">
                  <ClientAdd />
                </div>
              </div>
              <ul className="list">
                {
                  this.props.clients.list.map((client, i) => (
                    <li key={client._id} className="organization">
                      <div className="left">
                        <div className="top-line">
                          <div className="name">{client.name}</div>
                          <div className="date">
                          <Moment format="DD.MM.YYYY HH:mm:ss">
                            {new Date(client.date)}
                          </Moment>
                          </div>
                        </div>
                      </div>
                      <div className="details">
                        <div className="right">
                          Szczegóły
                        </div>
                      </div>
                    </li>
                  ))
                }
              </ul>
          </div>
      );
    }
}

Clients.propTypes = {
    addClient: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    clients: state.clients,
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps,{ addClient, listClients })(withRouter(Clients))
